// ListBilling.jsx
import React from "react";
import { Table, Message, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { size, map } from "lodash";
import { BillingItem } from "../ItemBilling/BillingItem";

export function ListBilling(props) {
  const { billings, isPartner } = props;
  // Dos namespaces: el propio de la pantalla y el comun, que ya trae
  // "Descripcion" y "Estado" para toda la plataforma.
  const { t } = useTranslation(["ui", "common"]);

  // Si aún no cargó o es null, no renderiza nada
  if (!billings) return null;

  // Si no hay facturas, mostramos un mensaje centrado
  if (size(billings) === 0) {
    return (
      <Message icon info style={{ marginTop: "2em", textAlign: "center" }}>
        <Icon name="file alternate outline" />
        <Message.Content>
          <Message.Header>{t("facturacion.lista.vaciaTitulo")}</Message.Header>
          {t("facturacion.lista.vaciaTexto")}
        </Message.Content>
      </Message>
    );
  }

  return (
    <Table compact celled className="list-billing">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            {t("facturacion.lista.cabecera.cliente")}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t("facturacion.lista.cabecera.contacto")}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t("facturacion.lista.cabecera.numero")}
          </Table.HeaderCell>
          <Table.HeaderCell>{t("common:fields.description")}</Table.HeaderCell>
          <Table.HeaderCell>
            {t("facturacion.lista.cabecera.total")}
          </Table.HeaderCell>
          {isPartner && (
            <Table.HeaderCell>
              {t("facturacion.lista.cabecera.comision")}
            </Table.HeaderCell>
          )}
          <Table.HeaderCell>{t("common:fields.status")}</Table.HeaderCell>
          <Table.HeaderCell>
            {t("facturacion.lista.cabecera.facturaCliente")}
          </Table.HeaderCell>
          {isPartner && (
            <Table.HeaderCell>
              {t("facturacion.lista.cabecera.facturaProveedor")}
            </Table.HeaderCell>
          )}
          <Table.HeaderCell>
            {t("facturacion.lista.cabecera.fechaAlta")}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {map(billings, (billing) => (
          <BillingItem
            key={billing._id}
            billing={billing}
            isPartner={isPartner}
          />
        ))}
      </Table.Body>
    </Table>
  );
}
